import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import PersonFormComponent from '../Person/PersonFormComponent';

import { formatSelect, required } from '../Forms/utils';

import { CHECKBOX, REACT_SELECT_INPUT } from '../Forms/fieldTypes';

const AdminUserFormComponent = (props) => {
  const { t } = useTransl();

  const {
    isMasterPM,
    isService,
    pmcs,
    buildings,
    hasSelectedPmcs,
    onSelectExisting,
    onLoad,
    onSubmit,
    formValues,
    formInitialValues,
    selectExisting,
    initialValues,
  } = props;

  const additionalFormData = [
    {
      keyName: 'isService',
      label: t('user.ccAgent'),
      fieldType: CHECKBOX,
      validate: null,
      isHidden: isMasterPM,
    },
    {
      keyName: 'pmcs',
      label: t('user.pmcs'),
      fieldType: REACT_SELECT_INPUT,
      multi: true,
      options: formatSelect(pmcs),
      validate: isMasterPM ? [required] : [],
      isHidden: isService,
    },
    {
      keyName: 'buildings',
      label: t('title.building_s'),
      fieldType: REACT_SELECT_INPUT,
      options: formatSelect(buildings),
      multi: true,
      validate: [],
      isHidden: isService || isMasterPM || !hasSelectedPmcs,
    },
  ];
  return (
    <PersonFormComponent
      title={t('actions.addAdmin')}
      formValues={formValues}
      formInitialValues={formInitialValues}
      additionalFormData={additionalFormData}
      onSelectExisting={onSelectExisting}
      onLoad={onLoad}
      onSubmit={onSubmit}
      selectExisting={selectExisting}
      initialValues={initialValues}
    />
  );
};

AdminUserFormComponent.defaultProps = {
  isMasterPM: true,
  isService: true,
  hasSelectedPmcs: false,
  selectExisting: {},
};

AdminUserFormComponent.propTypes = {
  pmcs: PropTypes.instanceOf(Array).isRequired,
  buildings: PropTypes.instanceOf(Array).isRequired,
  onLoad: PropTypes.func.isRequired,
  onSelectExisting: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formValues: PropTypes.instanceOf(Object).isRequired,
  formInitialValues: PropTypes.instanceOf(Object).isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  isMasterPM: PropTypes.bool,
  isService: PropTypes.bool,
  hasSelectedPmcs: PropTypes.bool,
  selectExisting: PropTypes.instanceOf(Object),
};

export default AdminUserFormComponent;
